import { FC } from "react"
import cx from "classnames"
import Modal, { ModalProps } from "@/components/Modal"
import CancelButton from "@/components/OutlineButton/CancelButton"
import DeleteButton from "@/components/Button/DeleteButton"
import { useAdminDeleteDNC } from "../../hooks/useAdminDeleteDNC"
import type { AdminDNC } from "@/types/entities/dnc"

type Props = {
  className?: string
  data: AdminDNC[]
  onDelete?: () => void
} & ModalProps

const DeleteDNCModal: FC<Props> = ({
  className,
  open,
  data,
  onClose,
  onDelete,
  ...rest
}: Props) => {
  const {
    deleteAdminDNC,
    response: { isLoading },
  } = useAdminDeleteDNC()
  if (!data.length) {
    return null
  }
  const handleDelete = async () => {
    try {
      const response = await deleteAdminDNC(data.map(({ _id }) => _id))
      if (response) {
        onDelete && onDelete()
      }
    } catch (e) {
      console.error(e)
    } finally {
      onClose && onClose()
    }
  }
  const title =
    data.length > 1 ? `Delete ${data.length} Accounts` : "Delete Account"
  const usersText =
    data.length > 1 ? `${data.length} accounts` : `“${data[0].value}”`
  return (
    <Modal
      title={title}
      open={open}
      onClose={onClose}
      className={cx("", className)}
      onSubmit={handleDelete}
      actions={
        <div className="flex gap-4">
          <CancelButton onClick={onClose} disabled={isLoading} />
          <DeleteButton disabled={isLoading} />
        </div>
      }
      {...rest}
    >
      <span className="leading-6 text-base break-all">
        Are you sure you want to delete{" "}
        <span className="font-semibold">{usersText}</span>?
      </span>
    </Modal>
  )
}

export default DeleteDNCModal
